import React, { forwardRef } from 'react'
import { Grid as BaseGrid, styled, TableContainer as BaseTableContainer } from '@mui/material'
import { TableCell as BaseTableCell } from '@chilecompra/react-kit/components'

export const BaseContainer = styled(forwardRef((props, ref) => <BaseGrid container ref={ref} {...props} />))`
  &.MuiGrid-container {
    gap: ${props => props.gap};
    margin: ${props => props.margin};
    padding: ${props => props.padding};
  }
`

export const BaseItem = styled(forwardRef((props, ref) => <BaseGrid item ref={ref} {...props} />))`
  &.MuiGrid-item {
    margin: ${props => props.margin};
    padding: ${props => props.padding};
  }
`

export const Container = styled(BaseContainer)``

export const HeadingInformation = styled(({ columns = 2, ...props }) => <div {...props} />)`
  display: grid;
  gap: 16px;
  grid-template-columns: ${({ columns }) => `repeat(${columns ?? 2}, 1fr)`};
`

export const Link = styled('a')`
  align-items: center;
  color: ${props => props.theme.palette.blue[50]};
  cursor: pointer;
  font-size: 14px;
  font-weight: 400;
  pointer-events: visible;
  text-decoration: underline;
`

export const Root = styled(BaseContainer)`
  gap: 26px;
  padding-top: 24px;
`

export const TableCell = styled(BaseTableCell)`
  &.MuiTableCell-root {
    padding: ${props => props.padding && `${props.padding} !important`};
  }
`

export const TableContainer = styled(BaseTableContainer)`
  &.MuiTableContainer-root {
    .MuiTableHead-root .MuiTableCell-root {
      border: none;
    }
  }
`
